import React, { useEffect, useRef } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import strokeRightSrc from '@cover/weiterstreiten/stroke-right.png';
import strokeLeftSrc from '@cover/weiterstreiten/stroke-left.png';
import goalsSrc from '@cover/weiterstreiten/word-9.png';
import desiresSrc from '@cover/weiterstreiten/word-10.png';

const Words = styled.img`
	position: absolute;
	height: 100%;
	top: 0;
	opacity: 0;
`

const StrokeRight = styled.img`
	position: absolute;
	height: 14%;
	bottom: 9%;
	right: -2%;
	opacity: 0;
`
const StrokeLeft = styled.img`
	position: absolute;
	height: 18%;
	bottom: -1%;
	left: -5%;
	opacity: 0;
`

const WeiterStreiten = ({ play }) => {
	const strokeRight = useRef(false);
	const strokeLeft = useRef(false);
	const words = useRef(false);
	const words2 = useRef(false);
	const goals = useRef(false);
	const desires = useRef(false);

	const layers = [];
	for (let n = 1; n <= 6; n++) {
		layers.push(<Words key={`word-${n}`} src={`/assets/cover/word-${n}.png`}/>)
	}

	const layers2 = [];
	for (let n = 7; n <= 8; n++) {
		layers2.push(<Words key={`word-${n}`} src={`/assets/cover/word-${n}.png`}/>)
	}

	useEffect(() => {
		const timeline = anime.timeline({
			autoplay: play,
			loop: true,
		});

		timeline
		.add({
			targets: words.current.children,
			easing: 'easeInSine',
			opacity: 1,
			delay: anime.stagger(400, {start: 550}),
			endDelay: 200
		})
		.add({
			targets: words2.current.children,
			easing: 'easeInSine',
			opacity: 1,
			delay: anime.stagger(400)
		})
		.add({
			targets: [goals.current, strokeLeft.current],
			easing: 'easeInSine',
			opacity: 1,
			delay: anime.stagger(400)
		})
		.add({
			targets: [desires.current, strokeRight.current],
			easing: 'easeInSine',
			duration: 300,
			delay: anime.stagger(400),
			opacity: 1,
			endDelay: 2000
		})
		.add({
			targets: [strokeRight.current, strokeLeft.current, words.current.children, words2.current.children, goals.current, desires.current],
			easing: 'easeInOutSine',
			duration: 800,
			opacity: 0,
			endDelay: 1400
		});
	}, [play])
	return (
		<>
			<StrokeRight src={strokeRightSrc} ref={strokeRight} />
			<StrokeLeft src={strokeLeftSrc} ref={strokeLeft} />
			<div ref={words}>{ layers }</div>
			<div ref={words2}>{ layers2 }</div>
			<Words src={goalsSrc} ref={goals} />
			<Words src={desiresSrc} ref={desires} />
		</>
	)
};

export default WeiterStreiten;